import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Render from "source/app/presentation/Shared/Render";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import UI from "source/app/services/UI/UI";

export function WorkflowsScrollIcon({
    direction,
    disabled,
}: {
    direction: "up" | "down";
    disabled: boolean;
}) {
    const isUp = direction === "up";

    return (
        <Render id={`scrollTo${isUp ? "Top" : "Bottom"}Icon`} when={true}>
            <IconWithText
                iconSuffix={EGlyphicon[isUp ? "arrow-up" : "arrow-down"]}
                whenClicked={() =>
                    !disabled &&
                    (isUp
                        ? UI.ScrollToFirst("[data-workflow-node]")
                        : UI.ScrollToLast("[data-workflow-node]"))
                }
                displayAsBlock={false}
            />
        </Render>
    );
}
